import React from 'react'
import { View, ViewStyle, TextStyle, Switch } from 'react-native'
import { Header, color, Text, iconArrowBack } from '@trivie/ui-mobile'
import { useStores } from '@trivie/core'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router'

export const EmailScreen = observer(() => {
  const { userStore } = useStores()
  const { user, isSubscriptionWorkspace } = userStore
  const history = useHistory()

  return (
    <View testID="EmailScreen" style={FULL}>
      <div style={CONTAINER}>
        <Header
          leftIcon={iconArrowBack}
          onLeftPress={() => history.goBack()}
          center
          style={HEADER}
          titleStyle={HEADER_TITLE}
          headerTx="Settings.Notifications.emailNotifications"
        />
        <fieldset style={FIELDSETS}>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingVertical: 20,
            }}
          >
            <View style={{ display: 'flex', flexDirection: 'column' }}>
              <Text variant="label" tx="Settings.Notifications.reinforcementEmails" />
              <Text
                variant="body2"
                tx="Settings.Notifications.reinforcementEmailsSubtitle"
                style={{ color: color.shade50 }}
              />
            </View>
            <Switch
              // @ts-ignore
              dataSet={{ qat: `reinforcements_notification_toggle` }}
              accessible
              accessibilityRole="switch"
              accessibilityLabel="[Reinforcements Emails]"
              trackColor={{ true: color.green, false: color.darkenGrey }}
              thumbColor="white"
              value={user?.user_comm_settings?.reinforcement_email_enabled || false}
              onValueChange={(value) => {
                userStore.setUserCommSettings({ reinforcement_email_enabled: value })
              }}
            />
          </View>

          {!isSubscriptionWorkspace && (
            <View
              style={{
                paddingVertical: 20,
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <View style={{ display: 'flex', flexDirection: 'column' }}>
                <Text variant="label" tx="Settings.Notifications.assignmentsEmails" />
                <Text
                  variant="body2"
                  tx="Settings.Notifications.assignmentsEmailsSubtitle"
                  style={{ color: color.shade50 }}
                />
              </View>
              <Switch
                // @ts-ignore
                dataSet={{ qat: `assignments_notification_toggle` }}
                accessible
                accessibilityRole="switch"
                accessibilityLabel="[Assignments Emails]"
                trackColor={{ true: color.green, false: color.darkenGrey }}
                thumbColor="white"
                value={user?.user_comm_settings?.assignments_email_enabled || false}
                onValueChange={(value) => {
                  userStore.setUserCommSettings({ assignments_email_enabled: value })
                }}
              />
            </View>
          )}

          <View
            style={{
              paddingVertical: 20,
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <View style={{ display: 'flex', flexDirection: 'column' }}>
              <Text variant="label" tx="Settings.Notifications.feedActivityEmails" />
              <Text
                variant="body2"
                tx="Settings.Notifications.feedActivityEmailsSubtitle"
                style={{ color: color.shade50 }}
              />
            </View>
            <Switch
              // @ts-ignore
              dataSet={{ qat: `feed_notification_toggle` }}
              accessible
              accessibilityRole="switch"
              accessibilityLabel="[Feed Activity Emails]"
              trackColor={{ true: color.green, false: color.darkenGrey }}
              thumbColor="white"
              value={user?.user_comm_settings?.feed_email_enabled || false}
              onValueChange={(value) => {
                userStore.setUserCommSettings({ feed_email_enabled: value })
              }}
            />
          </View>

          <View
            style={{
              paddingVertical: 20,
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <View style={{ display: 'flex', flexDirection: 'column' }}>
              <Text variant="label" tx="Settings.Notifications.leaderboardsEmails" />
              <Text
                variant="body2"
                tx="Settings.Notifications.leaderboardsEmailsSubtitle"
                style={{ color: color.shade50 }}
              />
            </View>
            <Switch
              // @ts-ignore
              dataSet={{ qat: `leaderboards_notification_toggle` }}
              accessible
              accessibilityRole="switch"
              accessibilityLabel="[Leaderboards Emails]"
              trackColor={{ true: color.green, false: color.darkenGrey }}
              thumbColor="white"
              value={user?.user_comm_settings?.leaderboard_email_enabled || false}
              onValueChange={(value) => {
                userStore.setUserCommSettings({ leaderboard_email_enabled: value })
              }}
            />
          </View>

          <View
            style={{
              paddingVertical: 20,
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <View style={{ display: 'flex', flexDirection: 'column' }}>
              <Text variant="label" tx="Settings.Notifications.surveysEmails" />
              <Text
                variant="body2"
                tx="Settings.Notifications.surveysEmailsSubtitle"
                style={{ color: color.shade50 }}
              />
            </View>
            <Switch
              // @ts-ignore
              dataSet={{ qat: `surveys_notification_toggle` }}
              accessible
              accessibilityRole="switch"
              accessibilityLabel="[Surveys Emails]"
              trackColor={{ true: color.green, false: color.darkenGrey }}
              thumbColor="white"
              value={user?.user_comm_settings?.survey_email_enabled || false}
              onValueChange={(value) => {
                userStore.setUserCommSettings({ survey_email_enabled: value })
              }}
            />
          </View>
        </fieldset>
      </div>
    </View>
  )
})

/**
 * Styling
 */
const FULL: ViewStyle = { flex: 1 }
const CONTAINER: React.CSSProperties = {
  backgroundColor: color.white,
}
const FIELDSETS: React.CSSProperties = { padding: 0, border: 'none' }
const HEADER_TITLE: TextStyle = { fontSize: 24, color: color.black }
const HEADER: ViewStyle = { marginBottom: 12 }
